export const BANNER_MESSAGE_TEST_ID = "banner_msg";
